import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ModalRef } from '@eg/ui';

@Component({
  selector: 'rmb-unsaved-changes-warning',
  templateUrl: './unsaved-changes-warning.component.html',
  styleUrl: './unsaved-changes-warning.component.scss',
  standalone: false,
})
export class UnsavedChangesWarningComponent {
  private modalRef = inject(ModalRef);

  @Input() source: string;
  @Output() response = new EventEmitter<boolean>();

  onCloseClick(): void {
    this.modalRef.close();
  }

  onResponseClick(response: string): void {
    if (response === 'yes') {
      this.response.emit(true);
    }
    if (response === 'cancel') {
      this.response.emit(false);
    }
    this.modalRef.close(response);
  }
}
